import Vue from 'vue'
import Router from 'vue-router'
import workerorderindex from '@/components/workorder/workerorderindex'
import workinformation from '@/components/workorder/workinformation'
import workaccount from '@/components/workorder/workacconnt'
import ServiceError from '@/components/im/serviceError'
import workcommit from '@/components/workorder/workcommit'
import workdetail from '@/components/workorder/workdetail'
import commitinfor from '@/components/workorder/butianinfor'
import inviteselect from '@/components/im/inviteselect'
import ImDirectory from '@/components/im/imDirectory'
import IMLineUp from '@/components/im/imLineUp'
import LoginMobile from '@/components/im/loginMobile'
import ImSession from '@/components/im/imSession'
import myorder from '@/components/workorder/myorder'
import beatis from '@/components/im/beatis'
import hello from '@/components/Hello'
import spirit from '@/components/spirit/spirit'
import callcenter from '@/components/callcenter/callcenter'
import aiInteractive from '@/components/question/aiInteractive'
import FaqPage from '@/components/question/faqPage'
import Receipt from '@/components/question/receipt'
import ImChat from '@/components/question/imChat'

Vue.use(Router)

export default new Router({
  routes: [
     {
      path: '/',
      name: 'hello',
      component: hello
    },
    {
      path: '/callcenter',
      name: 'callcenter',
      component: callcenter
    },
    {
      path: '/commitinfor',
      name: 'commitinfor',
      component: commitinfor
    },
    {
      path: '/workinformation',
      name: 'workinformation',
      component: workinformation
    },
    {
      path: '/workerorderindex',
      name: 'workerorderindex',
      component: workerorderindex
    },
    {
      path: '/workaccount',
      name: 'workaccount',
      component: workaccount
    },
    {
      path: '/workcommit',
      name: 'workcommit',
      component: workcommit
    },
    {
      path: '/workdetail',
      name: 'workdetail',
      component: workdetail
    }, {
      path: '/beatis',
      name: 'beatis',
      component: beatis
    },
    { // 服务器连接错误
      path: '/serviceError',
      name: 'ServiceError',
      component: ServiceError
    },{ // im 目录
      path: '/imDirectory',
      name: 'ImDirectory',
      component: ImDirectory
    },{ // im 目录
      path: '/inviteselect',
      name: 'inviteselect',
      component: inviteselect
    },{ // im 排队
      path: '/imLineUp',
      name: 'IMLineUp',
      component: IMLineUp
    },{ // 登陆
      path:'/loginMobile',
      name: 'LoginMobile',
      component: LoginMobile
    },{ // 会话
      path:'/imSession',
      name: 'ImSession',
      component: ImSession
    },
    {
      path:'/myorder',
      name: 'myorder',
      component: myorder
    },
    {
      path:'/spirit',
      name: 'spirit',
      component: spirit
    },
    {
      path: '/aiInteractive',
      name: 'AiInteractive',
      component: aiInteractive
    },
    {
      path: '/faqPage',
      name: 'FaqPage',
      component: FaqPage
    },
    {
      path: '/receipt',
      name: 'Receipt',
      component: Receipt
    },
    {
      path: '/imChat',
      name: 'imChat',
      component: ImChat
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js